import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from '@mui/material';
import moment from 'moment';
import { useState } from 'react';
import { GeneralReportCenter } from '../CustomerSelector';

type PotencyFactorMonthProps = {
  center: GeneralReportCenter;
};

const PotencyFactorMonth: React.FC<PotencyFactorMonthProps> = ({ center }) => {
  const [data, setData] = useState(-1);

  return (
    <Card style={{ height: '250px' }}>
      <CardHeader
        title={
          <Box
            component="div"
            display="flex"
            flexDirection="row"
            gap="5px"
            flexWrap={'wrap'}
          >
            <Typography variant="body1" fontWeight={600}>
              cos(fi) de este mes |
            </Typography>
            <Typography variant="body1">
              {moment().format('MMMM')} {new Date().getFullYear()}
            </Typography>
          </Box>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              component="div"
              display="flex"
              flexDirection="column"
              gap="5px"
              flexWrap={'wrap'}
            >
              <Typography variant="h5" fontWeight={600}>
                {data === -1 ? '0' : data.toFixed(2)}
              </Typography>
              <div style={{ height: '24px' }}></div>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box component="div" style={{ borderTop: '1px solid #009581' }} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" color="#009581">
              Factor de potencia
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PotencyFactorMonth;
